<template>
  <div class="drag-sort-pic-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <template
      v-if="questioninfo.content_audio&&questioninfo.content_audio!=''&&questioninfo.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent">
        <div>听力材料</div>
      </div>
    </template>
    <div class="drag-sort-pic-question-info-view" :style="showanswertype?'background:#fff':''">
      <div class="drag-sort-pic-question-content-info-view" v-if="!showanswertype">
        <div class="el-left-btn" v-if="localtoppage>1&&questioninfo.options.length>0" @click="prevtoppage"></div>
        <draggable :list="questioninfo.options"
                   :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false,dragClass:'drag-view'}"
                   @end="end"
                   class="group-drag1Area">
          <div v-for="(option,index) in questioninfo.options" v-if="index<5*localtoppage&&index>=(localtoppage-1)*5"
               :data-index="index" :data-url="option.img">
            <img :id="'dragpic'+index" class="drag-drop-group-item" :src="baseurl+option.img">
          </div>
        </draggable>
        <div class="el-right-btn" v-if="localtoppage<bottompages&&questioninfo.options.length>0"
             @click="nexttoppage"></div>
      </div>

      <div class="drag-sort-pic-question-content-info-view1">
        <div class="el-left-btn" v-if="localbottompage>1&&questioninfo.chosecontent.length>0"
             @click="prevbottompage"></div>
        <div class="grop-word-chose-item" v-for="(item,index) in questioninfo.chosecontent"
             v-if="index<5*localbottompage&&index>=(localbottompage-1)*5">
          <div class="index-text"><span v-if="item.list.length>0">{{index+1}}</span></div>
          <div class="drag-sort-pic-item">
            <div class="drag-sort-pic-index">{{index+1}}</div>
            <draggable
              :list="item.list"
              :options="{group:item.flags, sort: false ,filter: '.group-list-complete-item-handle',disabled: disabled}"
              :data-index="index"
              class="drag-drop-sort-pic-item">
              <div v-for="element in item.list">
                <div class="group-list-complete-item-handle" v-if="element"
                     :style="'background:url('+baseurl+element.img+');background-size:100% 100%;'"
                     @click="cancelchose(index,$event)"></div>
              </div>
            </draggable>
          </div>
          <!--<div class="answer-icon">-->
          <div :class="item.answertype?'answer-right':'answer-wrong'" v-if="showanswer"></div>
          <!--</div>-->
        </div>
        <div class="el-right-btn" v-if="localbottompage<bottompages&&questioninfo.chosecontent.length>0"
             @click="nextbottompage"></div>

      </div>
    </div>

    <audio ref="sortpicmusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';
  import draggable from 'vuedraggable'

  export default {
    name: "dragpicquestion",
    components: {draggable},
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        disabled: false,
        falgs: "article",
        toppages: 1,
        bottompages: 1,
        localtoppage: 1,
        localbottompage: 1,
        answerpages: 1,
        localanswerpages: 1,
        showanswer: false,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        audiourl: "",
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.sortpicmusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData);
        this.localindex = parseInt(localStorage.getItem("questionindex"));
        this.totalindex = parseInt(localStorage.getItem("questintotal"));
      },
      paraseData(questionData) {
        var that = this;
        var questiondata = {};
        if (!questionData.useroption) {
          questiondata = JSON.parse(JSON.stringify(this.questionData))
          var content = questiondata.content.replace(/<img>/g, "");
          var contents = content.split("|");
          questiondata.answers = contents
          var options = []
          var chosecontent = []
          contents.forEach(item => {
            options.push({
              img: item,
              list: [],
            })
            chosecontent.push({
              img: item,
              list: [],
              flags: "article"
            })
          })
          questiondata.options = that.randomSort(options);
          questiondata.chosecontent = chosecontent;
          questiondata.desc = questiondata.desc;
          questiondata.id = questiondata.id;
          questiondata.content_audio = questiondata.content_audio;
        } else {
          questiondata = JSON.parse(JSON.stringify(this.questionData))
        }
        console.log(questiondata)
        this.toppages = parseInt(Math.ceil(questiondata.options.length / 5));
        this.bottompages = parseInt(Math.ceil(questiondata.chosecontent.length / 5));
        this.answerpages = parseInt(questiondata.answers.length / 5 + 1)
        return questiondata;
      },
      prevbottompage() {
        this.localbottompage -= 1;
        if (this.localbottompage < 0) {
          this.localbottompage = 0
        }
      },
      nextbottompage() {
        this.localbottompage += 1;
        if (this.localbottompage > this.bottompages) {
          this.localbottompage = this.bottompages
        }
      },

      nexttoppage() {
        this.localtoppage += 1;
        if (this.localtoppage > this.toppages) {
          this.localtoppage = this.toppages
        }
      },
      prevtoppage() {
        this.localtoppage -= 1;
        if (this.localtoppage < 0) {
          this.localtoppage = 0
        }
      },
      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      end(ev) {
        if (ev.to.className == 'drag-drop-sort-pic-item') {
          this.isCanClick = true;
          if (ev.to.childElementCount == 1) {
            this.questioninfo.options.splice(ev.clone.dataset.index, 1)
            this.questioninfo.chosecontent[ev.to.dataset.index].flags = "111"
            this.questioninfo.chosecontent[ev.to.dataset.index].selectindex = ev.clone.dataset.index
            this.checkanswer();
          }
        }
      },
      cancelchose(index, event) {
        if (this.questioninfo.chosecontent[index].list.length > 0) {
          var item = this.questioninfo.chosecontent[index].list[0]
          this.questioninfo.chosecontent[index].flags = "article"
          this.questioninfo.chosecontent[index].list = []
          this.questioninfo.options.splice(this.questioninfo.chosecontent[index].selectindex, 0, item)
        }
        event.stopPropagation()
      },
      checkanswer() {
        var useroption = [];
        this.questioninfo.chosecontent.forEach((item, index) => {
          if (item.list.length > 0) {
            useroption.push([item.img, item.list[0].img])
          } else {
            useroption.push([item.img, ""])
          }
        })
        this.questioninfo.useroption = useroption;
        this.questioninfo.isfinish = true;
        this.$emit("questionfinish", this.questioninfo)
      },

      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.sortpicmusic.src = audiourl;
        if (this.$refs.sortpicmusic.paused) {
          this.$refs.sortpicmusic.play();
          this.contentplay = true;
        }
      },
      deschide() {
        this.showdesc = false;
        this.$refs.sortpicmusic.pause()

      },
      prev() {
        this.$refs.sortpicmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.sortpicmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .drag-sort-pic-question-view {
    width 100%;
    height 100%;
  }

  .drag-sort-pic-question-info-view {
    display flex;
    width 100%;
    height 75%;
    position relative;
    display flex;
    flex-direction column;
    justify-content space-around;
    align-items center;
  }

  .el-left-btn {
    width 38px;
    height 38px;
    position absolute;
    float left;
    left 18px;
    background url("../../assets/img/el-left-img.png");
    background-size 100% 100%;
  }

  .el-right-btn {
    width 38px;
    height 38px;
    position absolute;
    float right;
    right 18px;
    background url("../../assets/img/el-right-img.png");
    background-size 100% 100%;
  }

  .drag-sort-pic-question-content-info-view {
    width 95%;
    height 40%;
    margin 30px auto;
    display flex;
    flex-direction row;
    align-items center;
    justify-content space-around;
  }

  .show-answer-type-view {
    width 100%;
    font-size 30px;
    display: flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .show-answer-type-view img {
    width 280px;
    height 120px;
    margin-bottom 10px;
  }

  .drag-sort-pic-question-content-info-view1 {
    width 95%;
    height 60%;
    margin 10px auto;
    display flex;
    flex-direction row;
    align-items center;
    justify-content space-around;
  }

  .group-drag1Area {
    width 100%;
    height 100%;
    display flex;
    align-items center;
    justify-content space-around;
  }

  .drag-drop-group-item {
    width 177px;
    height 177px;
    border 3px solid #000;
    border-radius 12px;
  }

  .word-drag1Area-item {
    width 177px;
    height 177px;
    background #fff;
    border 3px solid #131313;
    font-size 36px;
    margin 5px;
    align-items center;
    display flex;
    justify-content center;
    border-radius 12px;
  }

  .drag-sort-pic-item {
    width 177px;
    height 177px;
    border 3px solid #000;
    border-radius 12px;
    display flex;
    align-items center;
    justify-content center;
  }

  .drag-sort-pic-index {
    font-size 60px;
    color #FF9A09;
  }

  .grop-word-chose-item {
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
    font-size 60px;

    .index-text {
      height 65px;
      margin-bottom 5px;
    }
  }

  .group-list-complete-item-handle {
    width 177px;
    height 177px;
    border-radius 12px;
  }

  .drag-drop-sort-pic-item {
    width 177px;
    height 177px;
    border 3px solid #000;
    border-radius 12px;
    position absolute;
    display flex;
    justify-content center;
    align-items center;
  }

  .answer-icon {
    width 50px;
    height 50px;
    margin-top 10px;
  }


  .show-drag-content-info {
    width 90%;
    height 100%;
    display flex;
    align-items center;
    justify-content space-around;
    position absolute;
    left 5%;
  }

  .answer-item-view {
    font-size 36px;
  }

  .show-drag-sort-pic-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;
    display flex;
    align-items center;

  }

  .answer-item-view img {
    width 180px;
    height 180px;
  }

  .sort-pic-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;
  }

  .sort-pic-finish-view {
    width 100%;
    height 90px;
    display flex;
    position absolute;
    bottom 0;
  }

  .sort-pic-finish-btn {
    width 50%;
    height 72px;
    font-size 36px;
    position absolute;
    left 25%;
    bottom 30px;
    border-radius 36px;
    background #5777FF;
    color #fff;
  }

  .answer-right-bottom-view img {
    margin-right 15px;
  }

  .answer-right-bottom-view {
    display flex;
    flex 1;
    height 100%;
    justify-content center;
    align-items center;
    color #fff;
    font-size 36px;
    background #92C761;
  }

  .sort-pic-finish-wrong {
    width: 100%;
    height 100%;
    display flex;
    justify-content center;
    align-items center;

    .answer-wrong-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #F45578;
    }

    .answer-wrong-bottom-view img {
      margin-right 15px;
    }

    .show-answer-btn {
      font-size 24px;
      color #fff;
      padding 0 15px;
      display flex;
      height 100%;
      flex-direction column;
      justify-content center;
      align-items center;
      background #92C761;
    }
  }

  .show-sort-pic-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 1500;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
  }

  .show-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;

    margin auto;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .show-answer-content-info {
    width 50%;
    height 96%;
    margin 1% auto;
    overflow-y auto;
    font-size 36px;
    text-align left;
    line-height 50px;
  }

  @media screen and (max-width: 1600px) {
    .drag-sort-pic-question-info-view {
    }

    .drag-drop-group-item {
      width 117px;
      height 117px;
      border 3px solid #000;
      border-radius 12px;
    }

    .drag-sort-pic-question-content-info-view {
      height 45%;
    }

    .drag-sort-pic-question-content-info-view1 {
      height 55%;
    }

    .show-answer-type-view {
      width 100%;
      font-size 24px;
      display: flex;
      flex-direction column;
      justify-content center;
      align-items center;
    }

    .show-answer-type-view img {
      width 240px;
      height 100px;
      margin-bottom 5px;
    }

    .drag-sort-pic-item {
      width 117px;
      height 117px;
      border 3px solid #000;
      border-radius 12px;
      display flex;
      align-items center;
      justify-content center;
    }

    .drag-sort-pic-index {
      font-size 40px;
      color #FF9A09;
    }

    .answer-right {
      width 25px;
      height 25px;
    }

    .answer-wrong {
      width 25px;
      height 25px;
    }

    .group-list-complete-item-handle {
      width 117px;
      height 117px;
      border-radius 12px;
    }

    .grop-word-chose-item {
      display flex;
      flex-direction column;
      justify-content center;
      align-items center;
      font-size 40px;

      .index-text {
        height 50px;
        margin-bottom 5px;
      }
    }

    .drag-drop-sort-pic-item {
      width 117px;
      height 117px;
      border 3px solid #000;
      border-radius 12px;
      position absolute;
      display flex;
      justify-content center;
      align-items center;
    }

    .sort-pic-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;
    }

    .sort-pic-finish-view {
      width 100%;
      height 50px;
      display flex;
      position absolute;
      bottom 0;
    }

    .sort-pic-finish-btn {
      width 50%;
      height 48px;
      font-size 24px;
      position absolute;
      left 25%;
      bottom 5px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .answer-right-bottom-view img {
      width 40px;
      height 40px;
      margin-right 15px;
    }

    .answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 24px;
      background #92C761;
    }

    .sort-pic-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #F45578;
      }

      .answer-wrong-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .drag-sort-pic-question-info-view {
      display flex;
      width 100%;
      height 80%;
      display flex;
      flex-direction column;
      justify-content space-around;
      align-items center;
    }

    .drag-drop-group-item {
      width 117px;
      height 117px;
      border 3px solid #000;
      border-radius 12px;
    }

    .drag-sort-pic-question-content-info-view {
      height 45%;
    }

    .drag-sort-pic-question-content-info-view1 {
      height 55%;
    }

    .show-answer-type-view {
      width 100%;
      font-size 24px;
      display: flex;
      flex-direction column;
      justify-content center;
      align-items center;
    }

    .show-answer-type-view img {
      width 240px;
      height 100px;
      margin-bottom 5px;
    }

    .drag-sort-pic-item {
      width 117px;
      height 117px;
      border 3px solid #000;
      border-radius 12px;
      display flex;
      align-items center;
      justify-content center;
    }

    .drag-sort-pic-index {
      font-size 40px;
      color #FF9A09;
    }

    .answer-right {
      width 25px;
      height 25px;
    }

    .answer-wrong {
      width 25px;
      height 25px;
    }

    .group-list-complete-item-handle {
      width 117px;
      height 117px;
      border-radius 12px;
    }

    .grop-word-chose-item {
      display flex;
      flex-direction column;
      justify-content center;
      align-items center;
      font-size 40px;

      .index-text {
        height 50px;
        margin-bottom 5px;
      }
    }

    .drag-drop-sort-pic-item {
      width 117px;
      height 117px;
      border 3px solid #000;
      border-radius 12px;
      position absolute;
      display flex;
      justify-content center;
      align-items center;
    }

    .sort-pic-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;
    }

    .sort-pic-finish-view {
      width 100%;
      height 50px;
      display flex;
      position absolute;
      bottom 0;
    }

    .sort-pic-finish-btn {
      width 50%;
      height 48px;
      font-size 24px;
      position absolute;
      left 25%;
      bottom 5px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .answer-right-bottom-view img {
      width 40px;
      height 40px;
      margin-right 15px;
    }

    .answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 24px;
      background #92C761;
    }

    .sort-pic-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #F45578;
      }

      .answer-wrong-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/dragsortpicquestion.vue